(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();
})();
